import { useState, useCallback, useRef } from "react";
import Link from "next/link";
import Items from "./Items";
import Pricing from "./Pricing";
import PaymentButton from "./PaymentButton";
import { Button } from "@/components/ui/button";
import { TriangleDots } from "@/components/CustomUI/modules/Loaders";

const ProductDetails = () => {
  const tawkLoadedInterval = useRef();
  const [tawkLoading, setTawkLoading] = useState(false);
  const handleClick = useCallback(() => {
    gtag('event', 'ivr_select');
  }, [])

  const onLiveChat = useCallback(() => {
    if (tawkLoadedInterval.current || tawkLoading) return
    setTawkLoading(true)
    tawkLoadedInterval.current = setInterval(() => {
      if (window.Tawk_API && window.Tawk_API.onLoaded && window.Tawk_API.toggle) {
        window.Tawk_API.toggle();
        clearInterval(tawkLoadedInterval.current)
        setTawkLoading(false)
      }
    }, 50)
  }, [ tawkLoading, tawkLoadedInterval ]);

  return (
    <div className="self-start mt-10 md:mt-0 w-full md:w-[45%] xl:w-[40%]">
      <div className="border rounded-sm border-slate-300 p-3">
        <Items />
        <Pricing />
        <PaymentButton />
      </div>
      <div className="text-center mt-5">
        <h3 className="mb-2 font-extrabold text-font-primaryMuted">
          24/7 Customer Service
        </h3>
        <div className="flex md:flex-col lg:flex-row items-center justify-around lg:justify-evenly font-light text-sm">
          <Link
            className="flex items-center gap-x-3 underline"
            href="tel:18002120299"
            onClick={handleClick}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width={25}
              height={25}
              viewBox="0 -0.5 17 17"
              version="1.1"
            >
              <defs></defs>
              <g stroke="none" strokeWidth={1} fill="none" fillRule="evenodd">
                <g transform="translate(1.000000, 0.000000)" fill="#434343">
                  <g transform="translate(0.000000, 2.000000)">
                    <path
                      d="M8.005,10.094 C6.563,10.094 5.098,9.238 4.243,8.105 C0.141,8.105 0.017,13.965 0.017,13.965 L15.992,13.965 C15.992,13.965 16.314,8.079 11.701,8.079 C10.847,9.226 9.447,10.094 8.005,10.094 Z"
                      className="si-glyph-fill"
                    ></path>
                    <path
                      d="M11.441,3.069 C11.441,4.755 9.902,7.979 8.002,7.979 C6.105,7.979 4.565,4.754 4.565,3.069 C4.565,1.384 6.104,0.016 8.002,0.016 C9.902,0.017 11.441,1.385 11.441,3.069 L11.441,3.069 Z"
                      className="si-glyph-fill"
                    ></path>
                  </g>
                  <path
                    d="M12.975,3.614 C12.975,3.298 12.535,3.043 11.989,3.041 L11.989,2.39 C11.989,2.293 12.026,0.022 8.014,0.022 C4.004,0.022 4.041,2.293 4.041,2.39 L4.041,3.064 C4.031,3.064 4.023,3.061 4.014,3.061 C3.471,3.061 3.034,3.312 3.034,3.623 L3.034,6.377 C3.034,6.686 3.472,6.938 4.014,6.938 C4.556,6.938 4.996,6.686 4.996,6.377 L4.996,3.623 C4.996,3.58 4.969,3.541 4.953,3.501 L4.953,2.75 C4.953,2.681 4.665,0.967 8.014,0.967 C11.364,0.967 11.016,2.681 11.016,2.75 L11.016,3.541 C11.01,3.566 10.991,3.588 10.991,3.614 L10.991,6.431 C10.991,6.748 11.434,7.005 11.983,7.005 C11.995,7.005 12.004,7.001 12.016,7.001 L12.016,8.03 L11.032,8.03 L11.032,9 L12.985,9 L12.975,3.614 L12.975,3.614 Z"
                    className="si-glyph-fill"
                  ></path>
                </g>
              </g>
            </svg>

            <span>1800-212-0299</span>
          </Link>

          <Button
            variant="secondary"
            className="
              bg-transparent hover:bg-transparent rounded-none 
              px-0 py-0 mx-0 border-0 cursor-pointer underline 
              flex items-center gap-x-3
            "
            onClick={onLiveChat}
          >
            {
              tawkLoading ? <TriangleDots loading={true} /> :
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width={25}
                  height={25}
                  viewBox="0 0 24 24"
                  fill="none"
                >
                  <path
                    d="M9 12.08L11 14L15 10"
                    stroke="#1C274C"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M17 3.33782C15.5291 2.48697 13.8214 2 12 2C6.47715 2 2 6.47715 2 12C2 13.5997 2.37562 15.1116 3.04346 16.4525C3.22094 16.8088 3.28001 17.2161 3.17712 17.6006L2.58151 19.8267C2.32295 20.793 3.20701 21.677 4.17335 21.4185L6.39939 20.8229C6.78393 20.72 7.19121 20.7791 7.54753 20.9565C8.88837 21.6244 10.4003 22 12 22C17.5228 22 22 17.5228 22 12C22 10.1786 21.513 8.47087 20.6622 7"
                    stroke="#1C274C"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                  />
                </svg>
            }

            <span>Chat With Us</span>
          </Button>
        </div>
      </div>
    </div>
  );
};

export default ProductDetails;
